enum Icons {
  AddressCard = 'f2bb',
  AngleDown = 'f107',
  AngleUp = 'f106',
  ArrowDown = 'f063',
  ArrowDownToLine = 'f33d',
  ArrowLeft = 'f060',
  ArrowLeftLong = 'f177',
  ArrowPointer = 'f245',
  ArrowRight = 'f061',
  ArrowRightArrowLeft = 'f0ec',
  ArrowRightFromBracket = 'f08b',
  ArrowRightToBracket = 'f090',
  ArrowRotateLeft = 'f0e2',
  ArrowRotateRight = 'f2f9',
  ArrowUp = 'f062',
  ArrowUpToLine = 'f341',
  BadgeCheck = 'f336',
  Bars = 'f0c9',
  BarsFilter = 'e0ad',
  BarsProgress = 'f828',
  Bell = 'f0f3',
  Bolt = 'f0e7',
  Box = 'f466',
  BoxArchive = 'f187',
  Bullhorn = 'f0a1',
  Calendar = 'f133',
  CalendarDay = 'f783',
  CalendarLinedPen = 'e472',
  Camera = 'f030',
  CameraViewfinder = 'e0da',
  ChartPie = 'f200',
  ChartSimple = 'e473',
  Check = 'f00c',
  ChevronDown = 'f078',
  ChevronLeft = 'f053',
  ChevronRight = 'f054',
  ChevronsLeft = 'f323',
  ChevronsRight = 'f324',
  ChevronUp = 'f077',
  Circle = 'f111',
  CircleCheck = 'f058',
  CircleExclamation = 'f06a',
  CircleHalfStroke = 'f042',
  CircleInfo = 'f05a',
  CircleNotch = 'f1ce',
  CircleQuestion = 'f059',
  CircleXMark = 'f057',
  ClipboardList = 'f46d',
  Clock = 'f017',
  ClockRotateLeft = 'f1da',
  Clone = 'f24d',
  CloudArrowUp = 'f0ee',
  CloudSlash = 'e137',
  Compass = 'f14e',
  Copy = 'f0c5',
  Cube = 'f1b2',
  Cubes = 'f1b3',
  EllipsisVertical = 'f142',
  Envelope = 'f0e0',
  EnvelopeDot = 'e16f',
  EnvelopeOpen = 'f2b6',
  Exclamation = '21',
  ExternalLinkSquare = 'f08e',
  Eye = 'f06e',
  EyeSlash = 'f070',
  FileExcel = 'f1c3',
  FileImport = 'f56f',
  FileInvoiceDollar = 'f571',
  FileLines = 'f15c',
  FileLock = 'e3a6',
  FilePdf = 'f1c1',
  FileShield = 'e247',
  FileSignature = 'f573',
  FileSlash = 'e3a7',
  FileXmark = 'f317',
  FileZipper = 'f1c6',
  Filter = 'f0b0',
  Flag = 'f024',
  FlagSwallowtail = 'f74c',
  FloppyDisk = 'f0c7',
  Folder = 'f07b',
  FolderOpen = 'f07c',
  Folders = 'f660',
  FolderTree = 'f802',
  Gear = 'f013',
  Gears = 'f085',
  Grid2 = 'e196',
  Handshake = 'f2b5',
  Highlighter = 'f591',
  House = 'f015',
  IdBadge = 'f2c1',
  IdCard = 'f2c2',
  Images = 'f302',
  Inbox = 'f01c',
  LayerGroup = 'f5fd',
  Link = 'f0c1',
  ListCheck = 'f0ae',
  LocationPin = 'f041',
  LocationPinSlash = 'f60c',
  Lock = 'f023',
  MagnifyingGlass = 'f002',
  Message = 'f27a',
  MessageLines = 'f4a6',
  MeterBolt = 'e1e9',
  Minus = 'f068',
  MoneyCheckDollarPen = 'f873',
  PaperPlane = 'f1d8',
  Pen = 'f304',
  Pencil = 'f303',
  PenFancy = 'f5ac',
  PenRuler = 'f5ae',
  PenSquare = 'f044',
  Plus = '2b',
  Receipt = 'f543',
  RectangleList = 'f022',
  RotateRight = 'f2f9',
  Ruler = 'f545',
  Server = 'f233',
  ShareNodes = 'f1e0',
  ShieldHalved = 'f3ed',
  SignalBars = 'f690',
  Signature = 'f5b7',
  Sort = 'f0dc',
  SortDown = 'f0dd',
  SortUp = 'f0de',
  Square = 'f0c8',
  SquareArrowUpRight = 'f14c',
  SquareCheck = 'f14a',
  SquareMinus = 'f146',
  SquarePlus = 'f0fe',
  Stamp = 'f5bf',
  Star = 'f005',
  Stars = 'f762',
  Stethoscope = 'f0f1',
  Stopwatch = 'f2f2',
  TableList = 'f00b',
  Tag = 'f02b',
  Tags = 'f02c',
  Trash = 'f1f8',
  TrashCan = 'f2ed',
  TriangleExclamation = 'f071',
  User = 'f007',
  UserCrown = 'f6a4',
  UserGroup = 'f500',
  UserGroupCrown = 'f6a5',
  Users = 'f0c0',
  UsersSlash = 'e073',
  Warehouse = 'f494',
  WarehouseFull = 'f495',
  Wrench = 'f0ad',
  Xmark = 'f00d',
}

export default Icons;
